<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('serialProfile.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('serialProfile.pageTitle'),
            href: '/admin/product-profiles',
          },
          {
            text: $t('productProfile.ViewAllSerial'),
            active: true,
          },
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-end">
          <div class="d-flex ts-space-x-3">
            <select
              class="form-control"
              style="width: 200px"
              v-model="sn_status_id"
              @change="fetchData"
            >
              <option
                v-for="(s, index) in serialStatus"
                :value="s.sn_status_id"
                :key="index"
              >
                {{ s.sn_status }}
              </option>
            </select>
            <ts-input
              v-tooltip="$t('productProfile.searchSerial')"
              v-model="search.text"
              :placeholder="$t('search')"
              style="width: 250px"
              class="inline-block"
            />
          </div>
        </div>
        <ts-loading-banner :loading="loading">
          <div class="ts-overflow-auto">
            <table class="ts-w-full ts-mt-3">
              <thead>
                <tr>
                  <th class="ts-uppercase ts-bg-gray-200 ts-py-2 ts-px-2 ts-w-32">
                    {{ $t('productProfile.serial') }}
                  </th>
                  <th class="ts-uppercase ts-bg-gray-200 ts-py-2 ts-px-2 ts-w-24">
                    {{ $t('productProfile.group') }}
                  </th>
                  <th class="ts-uppercase ts-bg-gray-200 ts-py-2 ts-px-2">
                    {{ $t('productProfile.productName') }}
                  </th>
                  <th class="ts-uppercase ts-bg-gray-200 ts-py-2 ts-px-2">
                    {{ $t('productProfile.imei') }}
                  </th>
                  <th class="ts-uppercase ts-bg-gray-200 ts-py-2 ts-px-2 ts-w-24">
                    {{ $t('productProfile.grade') }}
                  </th>
                  <th class="ts-uppercase ts-bg-gray-200 ts-py-2 ts-px-2 ts-w-24">
                    {{ $t('productProfile.productType') }}
                  </th>
                  <th class="ts-uppercase ts-bg-gray-200 ts-py-2 ts-px-2 ts-w-40">
                    {{ $t('productProfile.originalWarehouse') }}
                  </th>
                  <th class="ts-uppercase ts-bg-gray-200 ts-py-2 ts-px-2 ts-w-40">
                    {{ $t('productProfile.warehouse') }}
                  </th>
                  <th class="ts-uppercase ts-bg-gray-200 ts-py-2 ts-px-2 ts-w-32">
                    {{ $t('productProfile.status') }}
                  </th>
                  <th class="ts-uppercase ts-bg-gray-200 ts-py-2 ts-px-2 ts-w-32">
                    {{ $t('productProfile.qcBy') }}
                  </th>
                  <th class="ts-uppercase ts-bg-gray-200 ts-py-2 ts-px-2 ts-w-32">
                    {{ $t('productProfile.qcDate') }}
                  </th>
                  <th class="ts-uppercase ts-bg-gray-200 ts-py-2 ts-px-2 ts-w-32">
                    {{ $t('productProfile.remark') }}
                  </th>
                  <th class="ts-uppercase ts-bg-gray-200 ts-py-2 ts-px-2 ts-w-8">
                    {{ $t('actions') }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(r, index) in serialResources"
                  :key="index"
                  class="ts-cursor-pointer hover:ts-bg-gray-300"
                >
                  <td class="ts-py-1 ts-px-2">{{ r.serial_no }}</td>

                  <td class="ts-py-1 ts-px-2">
                    {{
                      r.product.group ? r.product.group.pro_group_name_en : null
                    }}
                  </td>
                  <td class="ts-py-1 ts-px-2">{{ r.product.product_name_en }}</td>
                  <td class="ts-py-1 ts-px-2">{{ r.imei }}</td>
                  <td class="ts-py-1 ts-px-2">
                    {{ r.product_grade }}
                  </td>
                  <td class="ts-py-1 ts-px-2">
                    {{ r.product.type.product_type_en }}
                  </td>
                  <td class="ts-py-1 ts-px-2">
                    {{ r.stock_in ? r.stock_in.location.location_name_en : '' }}
                  </td>
                  <td class="ts-py-1 ts-px-2">{{ r.location_name_en }}</td>
                  <td class="ts-py-1 ts-px-2">{{ r.sn_status }}</td>
                  <td class="ts-py-1 ts-px-2">{{ r.qc_by_user ? r.qc_by_user.employee_name_en : '' }}</td>
                  <td class="ts-py-1 ts-px-2">{{ r.qc_date }}</td>
                  <td class="ts-py-1 ts-px-2">{{ r.qc_remarks }}</td>
                  <td class="ts-py-1 ts-px-2 ts-text-center ts-space-x-3">
                    <a
                      href="#"
                      v-tooltip="$t('productProfile.viewHistory')"
                      @click.prevent="showHistory(r)"
                      ><i class="fas fa-eye"></i
                    ></a>
                    <a
                      href="#"
                      v-if="r.sn_status_id != 5"
                      v-tooltip="$t('productProfile.editImei')"
                      @click.prevent="updateImei(r)"
                      ><i class="fas fa-edit"></i
                    ></a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="d-flex justify-content-end ts-overflow-x-scroll ts-mt-3">
            <ts-pagination
              v-model="serialPagination"
              @navigate="fetchData"
            ></ts-pagination>
          </div>
          <a-modal
            v-if="show_history_serial"
            v-model="show_history_serial"
            :title="$t('productProfile.viewHistory')"
            :zIndex="1020"
            :footer="null"
            :maskClosable="false"
            width="70%"
          >
            <ts-loading-banner :loading="show_history_serial_waiting">
              <ViewSerialHistory :record="history" />
            </ts-loading-banner>
          </a-modal>
          <a-modal
            v-if="show_modal_update_imei_serial"
            v-model="show_modal_update_imei_serial"
            :title="$t('productProfile.editImei')"
            :zIndex="1020"
            :maskClosable="false"
            :okText="$t('save')"
            :cancelText="$t('cancel')"
            :confirmLoading="waiting_update"
            @ok="onSetImei"
            width="400px"
          >
            <ts-loading-banner
              :loading="update_imei_loading"
            >
              <div class="row">
                <div class="col-md-12 form-group">
                  <label class="ts-text-xs">{{
                    $t('productProfile.serial#')
                  }}</label>
                  <input
                    type="text"
                    v-model="model.serial_no"
                    class="form-control"
                    readonly
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 form-group">
                  <label class="ts-text-xs required">{{
                    $t('productProfile.imei')
                  }}</label>
                  <input
                    type="text"
                    v-model.trim="model.imei"
                    class="form-control"
                  />
                  <div class="validate" v-if="errors.has('imei')">
                    {{ errors.first('imei') }}
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 form-group">
                  <label class="ts-text-xs required">{{
                    $t('productProfile.productGrade')
                  }}</label>
                  <select class="form-control" v-model="model.product_grade">
                    <option value="A">A</option>
                    <option value="B">B</option>
                    <option value="C">C</option>
                    <option value="D">D</option>
                  </select>
                                  <div class="validate" v-if="errors.has('product_grade')">
                    {{ errors.first('product_grade') }}
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 form-group">
                  <label class="ts-text-xs required">{{
                    $t('productProfile.qcBy')
                  }}</label>
                  <a-select
                    show-search
                    v-model.number="model.qc_by"
                    :default-active-first-option="false"
                    :show-arrow="false"
                    :filter-option="false"
                    :not-found-content="null"
                    @search="handleSearchEmployee"
                    :defaultActiveFirstOption="true"
                    class="ts-w-full"
                  >
                    <a-select-option 
                      v-for="emp in employees" :key="emp.employee_id"
                    >
                      {{ emp.employee_name_en }}
                    </a-select-option>
                  </a-select>
                  <div class="validate" v-if="errors.has('qc_by')">
                    {{ errors.first('qc_by') }}
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 form-group">
                  <label class="ts-text-xs">{{
                    $t('productProfile.remark')
                  }}</label>
                  <textarea
                    rows="3"
                    class="form-control"
                    v-model="model.qc_remarks"
                  ></textarea>
                  <div class="validate" v-if="errors.has('qc_remarks')">
                    {{ errors.first('qc_remarks') }}
                  </div>
                </div>
              </div>
            </ts-loading-banner>
          </a-modal>
          <a-modal 
            :title="$t('pdf')" 
            width="500px" v-model="show_pdf" 
            :footer="null"
            @cancel="fetchData()"
          >
            <ts-preview-pdf v-model="waiting_update" :src="src" />
          </a-modal>
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { debounce } from 'lodash'
import { Errors } from 'form-backend-validation'
import ViewSerialHistory from './components/view-serial-history.vue'

export default {
  name: 'productAllSerialList',
  components: {
    ViewSerialHistory,
  },
  data() {
    return {
      src: null,
      show_pdf: false,
      loading: false,
      waiting_update: false,
      update_imei_loading: false,
      sn_status_id: 1,
      history: [],
      show_history_serial: false,
      show_modal_update_imei_serial: false,
      show_history_serial_waiting: false,
      errors: new Errors(),
      employees: [],
      employeeResources: [],
      search: {
        text: '',
      },
      model: {
        serial_no: '',
        imei: '',
        qc_remarks: '',
        qc_by: null,
        product_grade: '',
      },
    }
  },
  computed: {
    ...mapState('product/profile', [
      'serialResources',
      'serialPagination',
      'serialStatus',
    ]),
  },
  methods: {
    ...mapActions('product/profile', [
      'fetchSerialStatus',
      'fetchSerialHistory',
      'setImei',
      'employee'
    ]),
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('product/profile/fetchAllSerial', {
          filter: {
            search: this.search.text,
            sn_status_id: this.sn_status_id,
          },
          ...attributes,
        })
        .then((response) => {
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    showHistory(record) {
      this.show_history_serial = true
      this.show_history_serial_waiting = true
      this.history = []
      this.fetchSerialHistory(record.serial_no)
        .then((response) => {
          this.history = response.data
        })
        .catch((error) => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.show_history_serial_waiting = false
        })
    },
    updateImei(record) {
      this.fetchEmployee()
      this.errors = new Errors()
      this.show_modal_update_imei_serial = true
      this.model.serial_no = record.serial_no
      this.model.qc_remarks = record.qc_remarks
      this.model.qc_by = record.qc_by
      this.model.imei = record.imei
      this.model.product_grade = record.product_grade
    },
    onSetImei() {
      this.waiting_update = true
      this.src = null
      this.errors = new Errors()
      this.setImei(this.model)
        .then((response) => {
          this.show_pdf = true
          this.src = response.url
          this.show_modal_update_imei_serial = false
          
        })
        .catch((error) => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting_update = false
        })
    },
    fetchEmployee(){
      this.update_imei_loading = true
      this.employee()
        .then(response => {
          this.employees = response.data
        })
        .catch((error) => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.update_imei_loading = false
        })
    },
    handleSearchEmployee(value){
     let em = this.employees.find(em => em.card_id == value)
     if(em){
       this.model.qc_by = em.employee_id
     }
    }
  },
  watch: {
    'search.text': debounce(function (search) {
      this.fetchData()
    }, 500),
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData()
      vm.fetchSerialStatus()
    })
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('product/profile/SET_RESET_SERIAL_PAGE')
    this.$store.commit('product/profile/RESET_RESOURCES_SERIAL')
    next()
  },
}
</script>